import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { essencialModul } from '../diccionarios/essencialModulo';

@Injectable({
  providedIn: 'root'
})

export class EssencialService {

  urldMaestros: string;
  urlVDI: string;
  diccionarioUrl: any;
  
  constructor(private commom: CommonService,
              private utilServices: UtilsService) 
  {
        this.urldMaestros = this.utilServices.getDatosMaestros();
        this.urlVDI = this.utilServices.geturlVdi();
        //this.urldMaestros = "http://localhost:8080/dmaestros-api/v1/api/services/";
        this.diccionarioUrl = essencialModul.url;
  }

  getAll() {
    let url = this.urldMaestros + this.diccionarioUrl.essentialcrud;
    return this.commom.peticionGetConHeader(url);
  }

  getAllNivel(nivel, idJerarquia) {
    let url = this.urldMaestros + this.diccionarioUrl.essentialNivel + nivel+'/'+null
    if(idJerarquia != null ){
      url = this.urldMaestros + this.diccionarioUrl.essentialNivel + nivel +'/'+idJerarquia
    }    
    return this.commom.peticionGetConHeader(url);
  }

  getAllNivel_2() {
    let url = this.urldMaestros + this.diccionarioUrl.essentialcrud+"/all/nivel_2";
    return this.commom.peticionGetConHeader(url);
  }


  create(payload) {
    return this.commom.peticionPostConHeader(this.urldMaestros +this.diccionarioUrl.essentialcrud, payload);
  }

  update(payload) {
    return this.commom.peticionPutConHeader(this.urldMaestros +this.diccionarioUrl.essentialcrud, payload);
  }

  eliminar(id:string) {
    return this.commom.peticionDeleteConHeader(this.urldMaestros +this.diccionarioUrl.essentialcrud+"?id="+id);
  }

  cargaCsvValidador(formData: FormData){
    let url = this.urldMaestros + this.diccionarioUrl.csvEssential;
    return this.commom.peticionPostConHeader(url, formData);
  }

  saveCsvValidador(payload){
    let url = this.urldMaestros + this.diccionarioUrl.saveEssential;
    return this.commom.peticionPostConHeader(url, payload);
  }


// TICKET MANTENEDORES PARAMETROS B2C, PARA CREAR CLIENTES
crearRelacionGrupoSubcanal(payload) {
  const url = this.urlVDI +this.diccionarioUrl.grupoSubCanalcrud;
  return this.commom.peticionPostConHeader(url, payload);
}

eliminarRelacionGrupoSubcanal(payload) {
  const url = this.urlVDI +this.diccionarioUrl.grupoSubCanalcrud;
  return this.commom.peticionDeleteConHeader(url, payload);
}

getAllRelacionGrupoSubcanal() {
  const url = this.urlVDI +this.diccionarioUrl.grupoSubCanalcrud;
  return this.commom.peticionGetConHeader(url);
}

}



